// Copyright (C) 2020-2024 Northwestern University.

// This file is for issue #757 (disabling branding removal)
// Kept only the relevant part from
// https://github.com/inveniosoftware/invenio-app-rdm/blob/master/invenio_app_rdm/theme/assets/semantic-ui/js/invenio_app_rdm/landing_page/index.js
// with CommunitiesManagement -> GalterPrismCommunitiesManagement (indicated below)

import React from "react";
import ReactDOM from "react-dom";
import { GalterPrismCommunitiesManagement } from "./CommunitiesManagement";

const recordCitationAppDiv = document.getElementById("recordCitation");
const sidebarCommunitiesManageDiv = document.getElementById(
  "galter-prism-sidebar-communities-manage"
);

if (sidebarCommunitiesManageDiv) {
  const recordCommunitySearchConfig = JSON.parse(
    sidebarCommunitiesManageDiv.dataset.recordCommunitySearchConfig
  );
  const pendingCommunitiesSearchConfig =
    sidebarCommunitiesManageDiv.dataset.pendingCommunitiesSearchConfig;
  ReactDOM.render(
    // PRISM: Use overridden component
    <GalterPrismCommunitiesManagement
      userCommunitiesMemberships={JSON.parse(
        sidebarCommunitiesManageDiv.dataset.userCommunitiesMemberships
      )}
      recordCommunityEndpoint={
        sidebarCommunitiesManageDiv.dataset.recordCommunityEndpoint
      }
      recordUserCommunitySearchConfig={JSON.parse(
        sidebarCommunitiesManageDiv.dataset.recordUserCommunitySearchConfig
      )}
      canManageRecord={JSON.parse(sidebarCommunitiesManageDiv.dataset.canManageRecord)}
      recordCommunitySearchConfig={recordCommunitySearchConfig}
      permissions={JSON.parse(sidebarCommunitiesManageDiv.dataset.permissions)}
      searchConfig={JSON.parse(pendingCommunitiesSearchConfig)}
      record={JSON.parse(recordCitationAppDiv.dataset.record)}
    />,
    sidebarCommunitiesManageDiv
  );
}
